import { NoDataMessage } from '../../../components/NoDataMessage';
import { DynamicSkeleton } from '../../../components/DynamicSkeleton';
import { Table } from '../../../components/Table';
import { SupportTicket, TableColumn } from '../../../types/commonTypes';
import { Tag } from '../../../components/Tag';
import { SUPPORT_CATEGORIES } from '../supportCategories';

interface Props {
  isMobile: boolean;
  loading: boolean;
  onSelectedTicket(ticket: SupportTicket): void;
  pendingOnly: boolean;
  selectedTicket?: SupportTicket;
  tickets: SupportTicket[];
}

export const ViewTicketsTable = ({
  isMobile,
  loading,
  onSelectedTicket,
  pendingOnly,
  selectedTicket,
  tickets,
}: Props) => {
  const columns: TableColumn[] = [
    {
      name: 'Status',
      dataKey: 'behavior',
      width: 180,
      isHidden: isMobile,
    },
    {
      name: 'Subject',
      dataKey: 'subject',
      width: 400,
      minWidth: 400,
      isHidden: false,
    },
    {
      name: 'Ticket#',
      order: 1,
      dataKey: 'displayID',
      width: 125,
      isHidden: false,
    },
    {
      name: 'Type',
      dataKey: 'categoryName',
      width: 180,
      isHidden: isMobile,
    },
    {
      name: 'Created On',
      dataKey: 'createdAt',
      width: 200,
      isHidden: isMobile,
    },
    {
      name: 'Last Update',
      dataKey: 'lastUpdatedAt',
      width: 200,
      isHidden: isMobile,
    },
    {
      name: 'Last Update By',
      dataKey: 'lastUpdatedBy',
      width: 250,
      isHidden: isMobile,
    },
    {
      name: 'Priority',
      dataKey: 'priority',
      width: 100,
      isHidden: true,
    },
  ];

  if (loading)
    return (
      <div className="flex flex-col items-center justify-center w-full py-4 px-12">
        <div className="flex w-full">
          <NoDataMessage title="Loading Tickets..." />
        </div>
        <DynamicSkeleton
          direction="column"
          spacing={2}
          rowHeight={30}
          skeletons={['100%', '100%', '100%', '100%', '100%']}
        />
      </div>
    );
  else if (!loading && tickets !== undefined && tickets.length > 0)
    return (
      <Table
        customTool={
          pendingOnly ? (
            <span className="px-1">All Pending Tickets</span>
          ) : undefined
        }
        height={isMobile ? 460 : 400}
        columns={columns}
        data={tickets}
        loading={loading}
        csvName="TicketData.csv"
        singleSelect
        selectedItems={selectedTicket ? [selectedTicket] : undefined}
        onClick={onSelectedTicket}
        disableToolbar={isMobile}
        showTotalRows
        dataRenderProps={[
          {
            id: 'categoryName',
            component: (value) => (
              <Tag
                className={`mx-auto ${
                  SUPPORT_CATEGORIES.find((category) => category.name === value)
                    ?.tagClass ?? 'bg-gray-200 text-gray-800'
                }`}
                square
              >
                {value}
              </Tag>
            ),
          },
          {
            id: 'behavior',
            component: (value) => (
              <Tag className="bg-[#A3C7CF] text-[#0A4C5B]" square>
                {value}
              </Tag>
            ),
          },
        ]}
      />
    );
  else
    return (
      <div className="w-full h-full p-4">
        <NoDataMessage
          title="No tickets match the current filters."
          subTitle={
            pendingOnly
              ? 'Turn off Pending Only to include closed tickets.'
              : 'Try a different date range or site.'
          }
        />
      </div>
    );
};
